export interface Movie {
  id: number;
  title: string;
  titleEn: string;
  category: string;
  year: number;
  rating: number;
  posterUrl: string;
  heroUrl: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  releaseDate: string;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球2',
    titleEn: 'The Wandering Earth II',
    category: 'scifi',
    year: 2023,
    rating: 8.3,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20The%20Wandering%20Earth%202%20style%2C%20dark%20space%20background%20with%20warm%20orange%20planet%20glow%2C%20cinematic%20lighting%2C%20epic%20atmosphere%2C%20dramatic%20composition%2C%20professional%20film%20poster%20design%2C%20golden%20typography&width=600&height=840&seq=movie-poster-01&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%2C%20massive%20space%20station%20in%20orbit%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20dark%20blue%20tones%2C%20film%20grain%20texture%2C%20professional%20cinematography%2C%20atmospheric%20mood&width=1200&height=750&seq=movie-hero-01&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '173分钟',
    region: '中国大陆',
    tags: ['科幻', '灾难', '冒险', 'IMAX'],
    isHot: true,
    isNew: false,
    releaseDate: '2023-01-22',
  },
  {
    id: 2,
    title: '满江红',
    titleEn: 'Full River Red',
    category: 'drama',
    year: 2023,
    rating: 7.8,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%2C%20ancient%20Chinese%20courtyard%20at%20night%20with%20red%20lanterns%2C%20dark%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20dramatic%20shadows%2C%20professional%20film%20poster%20design%2C%20golden%20accents&width=600&height=840&seq=movie-poster-02&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20at%20night%2C%20red%20lanterns%20glowing%2C%20dark%20mysterious%20shadows%2C%20atmospheric%20period%20drama%20scene%2C%20cinematic%20lighting%2C%20professional%20film%20photography%2C%20dramatic%20mood&width=1200&height=750&seq=movie-hero-02&orientation=landscape',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    duration: '159分钟',
    region: '中国大陆',
    tags: ['悬疑', '喜剧', '历史'],
    isHot: true,
    isNew: false,
    releaseDate: '2023-01-22',
  },
  {
    id: 3,
    title: '速度与激情10',
    titleEn: 'Fast X',
    category: 'action',
    year: 2023,
    rating: 7.5,
    posterUrl: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20Fast%20and%20Furious%20style%2C%20sports%20car%20on%20fire%20in%20city%20street%2C%20explosive%20orange%20and%20dark%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20professional%20film%20poster%20design&width=600&height=840&seq=movie-poster-03&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Epic%20car%20chase%20scene%20in%20city%2C%20explosions%20and%20smoke%2C%20dramatic%20warm%20lighting%2C%20fast%20motion%20blur%2C%20cinematic%20action%20photography%2C%20professional%20film%20studio%20quality%2C%20dark%20moody%20atmosphere&width=1200&height=750&seq=movie-hero-03&orientation=landscape',
    description: '多年来，唐老大和他的家人克服了无数不可能的任务。如今他们面对有史以来最致命的对手——一个从过去的阴影中浮现的可怕威胁，他为了复仇不惜摧毁唐老大所珍视的一切。',
    director: '路易斯·莱特里尔',
    actors: ['范·迪塞尔', '杰森·斯坦森', '查理兹·塞隆'],
    duration: '141分钟',
    region: '美国',
    tags: ['动作', '冒险', '犯罪', '飙车'],
    isHot: true,
    isNew: true,
    releaseDate: '2023-05-17',
  },
  {
    id: 4,
    title: '铃芽之旅',
    titleEn: 'Suzume',
    category: 'anime',
    year: 2023,
    rating: 8.5,
    posterUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20style%2C%20beautiful%20sky%20with%20soft%20clouds%2C%20girl%20silhouette%20in%20flowing%20dress%2C%20dreamy%20pastel%20colors%20with%20golden%20light%2C%20cinematic%20lighting%2C%20atmospheric&width=600&height=840&seq=movie-poster-04&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20landscape%20scene%2C%20golden%20sunset%20sky%20with%20dramatic%20clouds%2C%20vast%20ocean%20view%2C%20serene%20atmosphere%2C%20cinematic%20anime%20style%2C%20warm%20golden%20lighting%2C%20dreamy%20aesthetic&width=1200&height=750&seq=movie-hero-04&orientation=landscape',
    description: '生活在九州乡间的17岁少女铃芽，遇到了一名正在寻找"门"的神秘青年草太。跟随着他的脚步，铃芽来到了山上一片废墟之地，在这里发现了一扇古老的门，由此展开了一段奇妙的旅程。',
    director: '新海诚',
    actors: ['原菜乃华', '松村北斗', '深津绘里'],
    duration: '122分钟',
    region: '日本',
    tags: ['动画', '奇幻', '冒险', '治愈'],
    isHot: true,
    isNew: true,
    releaseDate: '2023-03-24',
  },
  {
    id: 5,
    title: '独行月球',
    titleEn: 'Moon Man',
    category: 'comedy',
    year: 2022,
    rating: 7.9,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20sci-fi%20movie%20poster%2C%20astronaut%20on%20moon%20surface%20with%20humorous%20pose%2C%20dark%20space%20background%20with%20Earth%20in%20distance%2C%20cinematic%20lighting%2C%20professional%20film%20poster&width=600&height=840&seq=movie-poster-05&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20moon%20surface%20scene%2C%20astronaut%20standing%20alone%20on%20lunar%20landscape%2C%20Earth%20in%20dark%20sky%2C%20dramatic%20lighting%2C%20sci-fi%20atmosphere%2C%20professional%20film%20photography%2C%20moody%20tones&width=1200&height=750&seq=movie-hero-05&orientation=landscape',
    description: '人类为了抵御小行星的撞击，在月球部署了月盾计划。陨石提前来袭全员紧急撤离时，维修工独孤月因为意外错过了撤离通知，一个人落在了月球上，开始了他在月球上的破罐破摔的生活。',
    director: '张吃鱼',
    actors: ['沈腾', '马丽', '常远', '黄才伦', '辣目洋子'],
    duration: '122分钟',
    region: '中国大陆',
    tags: ['喜剧', '科幻', '温情'],
    isHot: false,
    isNew: false,
    releaseDate: '2022-07-29',
  },
  {
    id: 6,
    title: '奥本海默',
    titleEn: 'Oppenheimer',
    category: 'drama',
    year: 2023,
    rating: 8.8,
    posterUrl: 'https://readdy.ai/api/search-image?query=Biographical%20drama%20movie%20poster%2C%20man%20silhouette%20against%20nuclear%20explosion%2C%20black%20and%20white%20with%20fiery%20orange%20mushroom%20cloud%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20professional%20film%20poster&width=600&height=840&seq=movie-poster-06&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20black%20and%20white%20cinematic%20scene%2C%20nuclear%20test%20explosion%20in%20desert%2C%20mushroom%20cloud%20with%20warm%20orange%20glow%2C%20vintage%201940s%20aesthetic%2C%20professional%20film%20photography%2C%20atmospheric&width=1200&height=750&seq=movie-hero-06&orientation=landscape',
    description: '一部关于美国"原子弹之父"罗伯特·奥本海默的震撼传记片。聚焦他在二战期间主导曼哈顿计划开发原子弹的历程，以及战后所面临的政治迫害和道德困境。',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    duration: '180分钟',
    region: '美国',
    tags: ['传记', '历史', '剧情', '战争'],
    isHot: true,
    isNew: true,
    releaseDate: '2023-07-21',
  },
  {
    id: 7,
    title: '消失的她',
    titleEn: 'Lost in the Stars',
    category: 'drama',
    year: 2023,
    rating: 7.4,
    posterUrl: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%2C%20woman%20mysterious%20silhouette%20under%20water%2C%20deep%20blue%20and%20black%20tones%2C%20dramatic%20lighting%2C%20cinematic%20atmosphere%2C%20professional%20film%20poster%20design%2C%20enigmatic%20mood&width=600&height=840&seq=movie-poster-07&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20underwater%20cinematic%20scene%2C%20deep%20blue%20ocean%20with%20sunlight%20rays%2C%20suspenseful%20atmosphere%2C%20dramatic%20shadows%2C%20professional%20film%20photography%2C%20dark%20moody%20aesthetic&width=1200&height=750&seq=movie-hero-07&orientation=landscape',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失，当他苦寻无果之时，妻子再次现身，何非却坚持眼前这个女人并非自己的妻子。夫妻二人各执一词，背后隐藏着惊天秘密。',
    director: '崔睿 / 刘翔',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    duration: '122分钟',
    region: '中国大陆',
    tags: ['悬疑', '犯罪', '剧情'],
    isHot: true,
    isNew: false,
    releaseDate: '2023-06-22',
  },
  {
    id: 8,
    title: '巨齿鲨2：深渊',
    titleEn: 'Meg 2: The Trench',
    category: 'action',
    year: 2023,
    rating: 6.8,
    posterUrl: 'https://readdy.ai/api/search-image?query=Monster%20action%20movie%20poster%2C%20giant%20shark%20in%20deep%20ocean%2C%20dark%20blue%20underwater%20with%20dramatic%20light%20rays%2C%20cinematic%20lighting%2C%20professional%20film%20poster%20design%2C%20thrilling%20atmosphere&width=600&height=840&seq=movie-poster-08&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20trench%20cinematic%20scene%2C%20giant%20shark%20silhouette%20in%20dark%20water%2C%20dramatic%20underwater%20lighting%2C%20suspenseful%20atmosphere%2C%20professional%20film%20photography%2C%20dark%20moody%20blue%20tones&width=1200&height=750&seq=movie-hero-08&orientation=landscape',
    description: '乔纳斯·泰勒与中国科学家张九溟联手，带领研究团队潜入深海7000米之下进行探索。然而这次原本和平的深海之旅却意外遭遇史前巨兽巨齿鲨群的攻击。',
    director: '本·维特利',
    actors: ['杰森·斯坦森', '吴京', '蔡书雅', '克利夫·柯蒂斯'],
    duration: '119分钟',
    region: '美国/中国大陆',
    tags: ['动作', '科幻', '冒险', '怪兽'],
    isHot: false,
    isNew: true,
    releaseDate: '2023-08-04',
  },
  {
    id: 9,
    title: '人生路不熟',
    titleEn: 'Godspeed',
    category: 'comedy',
    year: 2023,
    rating: 7.2,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20road%20trip%20comedy%20movie%20poster%2C%20family%20in%20car%20on%20highway%20with%20beautiful%20landscape%2C%20warm%20sunset%20lighting%2C%20cinematic%20composition%2C%20professional%20film%20poster%20design%2C%20joyful%20atmosphere&width=600&height=840&seq=movie-poster-09&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Road%20trip%20cinematic%20scene%2C%20car%20driving%20on%20scenic%20highway%20at%20sunset%2C%20warm%20golden%20lighting%2C%20beautiful%20mountain%20landscape%2C%20professional%20film%20photography%2C%20heartwarming%20atmosphere&width=1200&height=750&seq=movie-hero-09&orientation=landscape',
    description: '车队大佬周东海和老婆霍梅梅阴差阳错地与女儿周微雨及女儿的男友万一帆同行自驾，踏上人生路不熟的探亲之旅。准岳父和准女婿一路斗智斗勇，笑料百出。',
    director: '易小星',
    actors: ['乔杉', '范丞丞', '马丽', '张婧仪', '常远'],
    duration: '100分钟',
    region: '中国大陆',
    tags: ['喜剧', '家庭', '公路'],
    isHot: false,
    isNew: false,
    releaseDate: '2023-04-28',
  },
  {
    id: 10,
    title: '银河护卫队3',
    titleEn: 'Guardians of the Galaxy Vol. 3',
    category: 'scifi',
    year: 2023,
    rating: 8.2,
    posterUrl: 'https://readdy.ai/api/search-image?query=Marvel%20superhero%20movie%20poster%2C%20space%20team%20in%20colorful%20cosmic%20background%2C%20vibrant%20purple%20and%20blue%20galaxy%2C%20cinematic%20lighting%2C%20dynamic%20composition%2C%20professional%20film%20poster%20design&width=600&height=840&seq=movie-poster-10&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Epic%20space%20battle%20cinematic%20scene%2C%20colorful%20galaxy%20with%20starships%2C%20vibrant%20cosmic%20colors%2C%20dramatic%20lighting%2C%20professional%20film%20photography%2C%20dynamic%20action%20atmosphere&width=1200&height=750&seq=movie-hero-10&orientation=landscape',
    description: '深受喜爱的银河护卫队成员们在虚无之地上安顿了下来，却很快因为火箭浣熊的动荡往事而陷入新的危机。星爵必须带领团队执行危险的任务，拯救火箭的生命。',
    director: '詹姆斯·古恩',
    actors: ['克里斯·帕拉特', '佐伊·索尔达娜', '戴夫·巴蒂斯塔', '布莱德利·库珀'],
    duration: '150分钟',
    region: '美国',
    tags: ['科幻', '动作', '冒险', '喜剧'],
    isHot: true,
    isNew: false,
    releaseDate: '2023-05-05',
  },
  {
    id: 11,
    title: '长津湖之水门桥',
    titleEn: 'The Battle at Lake Changjin II',
    category: 'action',
    year: 2022,
    rating: 7.9,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%2C%20soldiers%20in%20snow%20battle%2C%20cold%20winter%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20professional%20film%20poster%20design%2C%20heroic%20mood%2C%20dark%20tones&width=600&height=840&seq=movie-poster-11&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=War%20battle%20in%20snowy%20mountain%20cinematic%20scene%2C%20soldiers%20fighting%20in%20blizzard%2C%20cold%20blue%20and%20white%20tones%2C%20dramatic%20lighting%2C%20professional%20film%20photography%2C%20heroic%20atmosphere&width=1200&height=750&seq=movie-hero-11&orientation=landscape',
    description: '以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了在结束了新兴里和下碣隅里的战斗之后，七连战士们又接到了更艰巨的任务——炸毁水门桥，阻挡美军撤退。',
    director: '徐克',
    actors: ['吴京', '易烊千玺', '朱亚文', '李晨', '段奕宏'],
    duration: '149分钟',
    region: '中国大陆',
    tags: ['战争', '历史', '动作'],
    isHot: false,
    isNew: false,
    releaseDate: '2022-02-01',
  },
  {
    id: 12,
    title: '你的婚礼',
    titleEn: 'My Love',
    category: 'love',
    year: 2021,
    rating: 6.5,
    posterUrl: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20youth%20movie%20poster%2C%20couple%20on%20beach%20at%20sunset%2C%20warm%20golden%20lighting%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20professional%20film%20poster%20design%2C%20tender%20mood&width=600&height=840&seq=movie-poster-12&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20beach%20sunset%20cinematic%20scene%2C%20couple%20walking%20on%20shore%2C%20warm%20golden%20lighting%2C%20romantic%20atmosphere%2C%20professional%20film%20photography%2C%20dreamy%20aesthetic&width=1200&height=750&seq=movie-hero-12&orientation=landscape',
    description: '高中时，游泳特长生周潇齐对转校生尤咏慈一见钟情。年少懵懂的纯纯爱恋，男孩默默守护，女孩却不告而别。此后的人生，15年的爱情长跑，两人的命运再次交织在一起。',
    director: '韩天',
    actors: ['许光汉', '章若楠', '丁冠森', '晏紫东'],
    duration: '115分钟',
    region: '中国大陆',
    tags: ['爱情', '青春', '校园'],
    isHot: false,
    isNew: false,
    releaseDate: '2021-04-30',
  },
  {
    id: 13,
    title: '这么多年',
    titleEn: 'All These Years',
    category: 'love',
    year: 2023,
    rating: 7.1,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20youth%20romance%20movie%20poster%2C%20high%20school%20couple%20in%20classroom%2C%20soft%20warm%20lighting%2C%20nostalgic%20atmosphere%2C%20cinematic%20composition%2C%20professional%20film%20poster%20design%2C%20tender%20mood&width=600&height=840&seq=movie-poster-13&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=High%20school%20classroom%20cinematic%20scene%2C%20sunlight%20streaming%20through%20windows%2C%20warm%20nostalgic%20atmosphere%2C%20youth%20romance%20mood%2C%20professional%20film%20photography%2C%20golden%20hour%20lighting&width=1200&height=750&seq=movie-hero-13&orientation=landscape',
    description: '从小生活在重男轻女环境中的女孩陈见夏，在振华中学遇见了叛逆却心地善良的浑小子李燃。两人从互不待见到暗生情愫，却因为种种现实原因错过了彼此多年。',
    director: '季竹青',
    actors: ['张新成', '孙千', '章若楠', '刘丹'],
    duration: '116分钟',
    region: '中国大陆',
    tags: ['爱情', '青春', '成长'],
    isHot: false,
    isNew: true,
    releaseDate: '2023-04-28',
  },
  {
    id: 14,
    title: '修女2',
    titleEn: 'The Nun II',
    category: 'horror',
    year: 2023,
    rating: 6.9,
    posterUrl: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%2C%20dark%20nun%20figure%20in%20gothic%20church%2C%20eerie%20green%20and%20black%20tones%2C%20cinematic%20lighting%2C%20terrifying%20atmosphere%2C%20professional%20film%20poster%20design%2C%20haunting%20mood&width=600&height=840&seq=movie-poster-14&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Dark%20gothic%20church%20interior%20cinematic%20scene%2C%20candlelight%20shadows%2C%20eerie%20green%20tones%2C%20haunting%20atmosphere%2C%20horror%20film%20aesthetic%2C%20professional%20cinematography%2C%20dark%20moody%20lighting&width=1200&height=750&seq=movie-hero-14&orientation=landscape',
    description: '1956年的法国，一名牧师惨遭谋杀，某种邪恶正在蔓延。艾琳修女将再次与鬼修女瓦拉克展开正面对决，揭开隐藏在修道院中的黑暗秘密。',
    director: '迈克尔·查维斯',
    actors: ['泰莎·法米加', '乔纳斯·布洛凯', '斯托姆·瑞德'],
    duration: '110分钟',
    region: '美国',
    tags: ['恐怖', '惊悚', '悬疑'],
    isHot: false,
    isNew: true,
    releaseDate: '2023-09-08',
  },
  {
    id: 15,
    title: '长安三万里',
    titleEn: 'Chang An',
    category: 'anime',
    year: 2023,
    rating: 8.3,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20anime%20movie%20poster%2C%20ancient%20Tang%20dynasty%20cityscape%2C%20warm%20golden%20and%20red%20tones%2C%20traditional%20Chinese%20painting%20style%2C%20cinematic%20lighting%2C%20epic%20composition%2C%20professional%20film%20poster&width=600&height=840&seq=movie-poster-15&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20city%20cinematic%20scene%2C%20golden%20palace%20and%20pagodas%2C%20warm%20sunset%20lighting%2C%20traditional%20Chinese%20aesthetic%2C%20epic%20scale%2C%20professional%20animation%20style&width=1200&height=750&seq=movie-hero-15&orientation=landscape',
    description: '安史之乱后数年，吐蕃大军入侵西南，大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军回忆起自己与李白的一生往事，两位大诗人跌宕起伏的命运由此缓缓展开。',
    director: '谢君伟 / 邹靖',
    actors: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    duration: '168分钟',
    region: '中国大陆',
    tags: ['动画', '历史', '诗歌', '传记'],
    isHot: true,
    isNew: true,
    releaseDate: '2023-07-08',
  },
  {
    id: 16,
    title: '年会不能停！',
    titleEn: 'Johnny Keep Walking!',
    category: 'comedy',
    year: 2023,
    rating: 8.0,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20movie%20poster%2C%20office%20workers%20at%20annual%20party%2C%20colorful%20festive%20lighting%2C%20humorous%20atmosphere%2C%20cinematic%20composition%2C%20professional%20film%20poster%20design%2C%20vibrant%20mood&width=600&height=840&seq=movie-poster-16&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Large%20company%20annual%20party%20cinematic%20scene%2C%20colorful%20stage%20lights%2C%20crowd%20cheering%2C%20festive%20atmosphere%2C%20warm%20lighting%2C%20professional%20film%20photography%2C%20celebratory%20mood&width=1200&height=750&seq=movie-hero-16&orientation=landscape',
    description: '钳工胡建林阴差阳错被调入集团总部，与人事经理马杰和外包员工潘怡然卷入了一场职场斗争。三人在年会前夕展开了一场啼笑皆非的职场大冒险。',
    director: '董润年',
    actors: ['大鹏', '白客', '庄达菲', '王迅', '孙艺洲'],
    duration: '117分钟',
    region: '中国大陆',
    tags: ['喜剧', '职场', '讽刺'],
    isHot: true,
    isNew: true,
    releaseDate: '2023-12-29',
  },
  {
    id: 17,
    title: '碟中谍7：致命清算（上）',
    titleEn: 'Mission: Impossible – Dead Reckoning Part One',
    category: 'action',
    year: 2023,
    rating: 7.8,
    posterUrl: 'https://readdy.ai/api/search-image?query=Spy%20action%20movie%20poster%2C%20agent%20running%20through%20European%20city%2C%20dramatic%20warm%20and%20dark%20tones%2C%20cinematic%20lighting%2C%20dynamic%20composition%2C%20professional%20film%20poster%20design%2C%20thrilling%20mood&width=600&height=840&seq=movie-poster-17&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Epic%20motorcycle%20chase%20through%20European%20city%20cinematic%20scene%2C%20dramatic%20lighting%2C%20fast%20motion%2C%20professional%20film%20photography%2C%20thrilling%20action%20atmosphere%2C%20warm%20golden%20hour&width=1200&height=750&seq=movie-hero-17&orientation=landscape',
    description: '伊森·亨特和他的IMF团队开启了迄今为止最危险的任务：追踪一种会危及全人类的新型武器。面对神秘而强大的敌人，伊森被迫面对抉择：任务大于生命。',
    director: '克里斯托弗·麦奎里',
    actors: ['汤姆·克鲁斯', '海莉·阿特维尔', '丽贝卡·弗格森'],
    duration: '164分钟',
    region: '美国',
    tags: ['动作', '特工', '冒险', '惊悚'],
    isHot: false,
    isNew: true,
    releaseDate: '2023-07-14',
  },
  {
    id: 18,
    title: '蜘蛛侠：纵横宇宙',
    titleEn: 'Spider-Man: Across the Spider-Verse',
    category: 'anime',
    year: 2023,
    rating: 8.6,
    posterUrl: 'https://readdy.ai/api/search-image?query=Animated%20superhero%20movie%20poster%2C%20spider-man%20swinging%20through%20colorful%20city%2C%20vibrant%20comic%20book%20style%2C%20dynamic%20composition%2C%20cinematic%20lighting%2C%20professional%20film%20poster%20design&width=600&height=840&seq=movie-poster-18&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20comic%20book%20style%20cityscape%20cinematic%20scene%2C%20spider-man%20silhouette%20against%20colorful%20buildings%2C%20dynamic%20action%2C%20graffiti%20art%20style%2C%20professional%20animation%20quality%2C%20energetic%20atmosphere&width=1200&height=750&seq=movie-hero-18&orientation=landscape',
    description: '与格温·史黛西重逢后，布鲁克林的全职友好邻居蜘蛛侠迈尔斯被弹射穿越多元宇宙，与一群蜘蛛侠相遇。但当英雄们对如何处理新威胁产生分歧时，迈尔斯发现自己与其他蜘蛛侠陷入冲突。',
    director: '乔伊姆·多斯·桑托斯',
    actors: ['沙梅克·摩尔', '海莉·斯坦菲尔德', '奥斯卡·伊萨克'],
    duration: '140分钟',
    region: '美国',
    tags: ['动画', '动作', '冒险', '超级英雄'],
    isHot: true,
    isNew: false,
    releaseDate: '2023-06-02',
  },
  {
    id: 19,
    title: '封神第一部：朝歌风云',
    titleEn: 'Creation of the Gods I',
    category: 'action',
    year: 2023,
    rating: 7.7,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%2C%20ancient%20Chinese%20warrior%20with%20magical%20elements%2C%20golden%20and%20crimson%20tones%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20professional%20film%20poster%20design&width=600&height=840&seq=movie-poster-19&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20battlefield%20cinematic%20scene%2C%20thousands%20of%20warriors%20with%20banners%2C%20dramatic%20golden%20lighting%2C%20mythological%20atmosphere%2C%20professional%20film%20photography%2C%20grand%20scale&width=1200&height=750&seq=movie-hero-19&orientation=landscape',
    description: '殷商末年，纣王暴虐无道，宠爱狐妖妲己。昆仑仙人姜子牙携封神榜下山，寻找天下共主。西伯侯之子姬发逐渐发现纣王的真面目，一场天地变色的大战即将展开。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    duration: '148分钟',
    region: '中国大陆',
    tags: ['奇幻', '动作', '史诗', '神话'],
    isHot: true,
    isNew: false,
    releaseDate: '2023-07-20',
  },
  {
    id: 20,
    title: '芭比',
    titleEn: 'Barbie',
    category: 'comedy',
    year: 2023,
    rating: 7.3,
    posterUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20comedy%20movie%20poster%2C%20pink%20dreamy%20world%20with%20fashion%20dolls%2C%20vibrant%20pink%20and%20pastel%20colors%2C%20cinematic%20lighting%2C%20whimsical%20composition%2C%20professional%20film%20poster%20design%2C%20playful%20mood&width=600&height=840&seq=movie-poster-20&orientation=portrait',
    heroUrl: 'https://readdy.ai/api/search-image?query=Dreamy%20pink%20fantasy%20world%20cinematic%20scene%2C%20colorful%20dollhouse%20style%20buildings%2C%20vibrant%20pink%20and%20pastel%20lighting%2C%20whimsical%20atmosphere%2C%20professional%20film%20photography%2C%20playful%20aesthetic&width=1200&height=750&seq=movie-hero-20&orientation=landscape',
    description: '在梦幻般的芭比乐园，各种各样的芭比和肯每天都过着童话般完美的生活。但某一天，芭比发现自己的生活开始出现变化，她被迫前往真实世界探寻真相。',
    director: '格蕾塔·葛韦格',
    actors: ['玛格特·罗比', '瑞恩·高斯林', '亚美莉卡·费雷拉'],
    duration: '114分钟',
    region: '美国',
    tags: ['喜剧', '奇幻', '冒险'],
    isHot: false,
    isNew: false,
    releaseDate: '2023-07-21',
  },
];

export const articles: Record<number, {
  content: string;
  highlights: string[];
  relatedMovies: number[];
  faqs: { question: string; answer: string }[];
}> = {
  1: {
    content: `<p>《流浪地球2》以提出计划将建造1万座行星发动机的时代为故事背景，讲述了"太阳危机"即将来袭，世界陷入一片恐慌之中，万座行星发动机正在建造中，人类将面临末日灾难与生命存续的双重挑战。</p><p>本片由郭帆执导，吴京、刘德华、李雪健、沙溢、宁理等主演，于2023年大年初一上映。作为《流浪地球》的前传，影片展现了更为宏大壮观的世界观和更加震撼的视觉特效。</p><p>影片中的太空电梯、行星发动机、月球基地等元素的呈现令人叹为观止，将中国科幻电影的制作水准推向新的高度。影片不仅有着惊险刺激的灾难场面，还深入探讨了人类命运共同体、科技伦理、人工智能等深刻主题。</p>`,
    highlights: ['宏大的科幻世界观', '震撼的视觉特效盛宴', '吴京刘德华同台飙戏', '深度探讨AI与人类关系'],
    relatedMovies: [10, 8, 15],
    faqs: [
      { question: '《流浪地球2》是什么时候上映的？', answer: '《流浪地球2》于2023年1月22日（大年初一）在中国内地上映。' },
      { question: '《流浪地球2》时长多少？', answer: '《流浪地球2》的片长为173分钟。' },
      { question: '《流浪地球2》需要看第一部吗？', answer: '《流浪地球2》是第一部的故事前传，即使没有看过第一部也完全可以理解剧情，不过看过第一部会有更好的观影体验。' },
    ],
  },
  2: {
    content: `<p>《满江红》是由张艺谋执导，沈腾、易烊千玺担任双男主，张译、雷佳音、岳云鹏等联合主演的悬疑喜剧电影。影片以南宋绍兴年间为背景，讲述了一段关于忠诚与背叛、正义与阴谋的精彩故事。</p><p>电影采用独特的"剧本杀"式叙事结构，在一个封闭的宰相府邸中展开，层层递进，反转不断。张艺谋导演巧妙地将中国传统文化元素与现代叙事手法结合，打造出一部既有商业性又有艺术追求的作品。</p>`,
    highlights: ['张艺谋导演力作', '悬疑与喜剧的完美结合', '全明星豪华阵容', '层层反转的精彩剧情'],
    relatedMovies: [7, 9, 19],
    faqs: [
      { question: '《满江红》的导演是谁？', answer: '《满江红》由著名导演张艺谋执导。' },
      { question: '《满江红》讲的是什么故事？', answer: '影片讲述南宋绍兴年间，岳飞死后四年，一个小兵与亲兵营副统领被卷入一场巨大阴谋之中，在宰相府邸中抽丝剥茧寻找真相的故事。' },
    ],
  },
  3: {
    content: `<p>《速度与激情10》是该系列电影的第十部主线作品，由路易斯·莱特里尔执导，范·迪塞尔、杰森·斯坦森、查理兹·塞隆等主演。影片延续了该系列一贯的高强度动作场面和惊险刺激的飙车戏码。</p><p>本集中，唐老大和他的家人面临有史以来最致命的对手——但丁（杰森·莫玛饰），他从过去的阴影中浮现，为了复仇不惜一切代价。影片在全球多地取景拍摄，动作场面全面升级。</p>`,
    highlights: ['系列最强大反派登场', '全球多地实景拍摄', '热血飙车场面升级', '家族情怀继续延伸'],
    relatedMovies: [8, 17, 19],
    faqs: [
      { question: '《速度与激情10》是最终章吗？', answer: '《速度与激情10》不是最终章，该系列计划以三部曲形式收官，本片为最终三部曲的第一部。' },
    ],
  },
  4: {
    content: `<p>《铃芽之旅》是新海诚导演继《你的名字。》《天气之子》之后的又一部力作。影片以日本各地的废墟为舞台，讲述了少女铃芽为了关闭导致灾祸的"门"而踏上旅程的冒险故事。</p><p>影片将奇幻冒险与青春成长完美融合，画面精美绝伦，每一帧都可以截图做壁纸。新海诚独特的视觉风格和细腻的情感表达在片中得到了充分展现。</p>`,
    highlights: ['新海诚三年磨一剑', '每一帧都是壁纸级别', '温暖治愈的冒险故事', '全球票房超3亿美元'],
    relatedMovies: [18, 15, 12],
    faqs: [
      { question: '《铃芽之旅》是新海诚的哪部作品？', answer: '新海诚继《你的名字。》和《天气之子》之后的第三部长篇动画电影。' },
    ],
  },
  5: {
    content: `<p>《独行月球》是一部由张吃鱼执导，沈腾、马丽主演的科幻喜剧电影。影片讲述了人类为了抵御小行星撞击，在月球部署了月盾计划，维修工独孤月意外被遗落在月球，开始了他在月球上的独居生活。</p><p>影片以其独特的科幻喜剧风格，融合了爆笑、温情和感动。沈腾在片中的独角戏表演令人捧腹又心酸，展示了他作为喜剧演员的深厚功力。</p>`,
    highlights: ['沈腾独角戏演技爆发', '科幻与喜剧的奇妙碰撞', '笑中带泪的感人故事', '票房突破31亿'],
    relatedMovies: [9, 16, 10],
    faqs: [
      { question: '《独行月球》票房多少？', answer: '《独行月球》最终票房超过31亿人民币，是2022年暑期档的票房冠军。' },
    ],
  },
  6: {
    content: `<p>《奥本海默》是克里斯托弗·诺兰执导的传记电影，由基里安·墨菲饰演罗伯特·奥本海默。影片改编自获奖传记《美国普罗米修斯：奥本海默的胜与悲》。</p><p>诺兰以其标志性的非线性叙事手法，展现了奥本海默在曼哈顿计划中的关键角色，以及战后他因政治立场遭受的调查和迫害。采用IMAX胶片摄影机拍摄，不用CGI特效还原了三位一体核试验的震撼场面。</p>`,
    highlights: ['诺兰导演生涯巅峰之作', '真实还原三位一体核试验', '基里安·墨菲封神级表演', '全球票房破9亿美元'],
    relatedMovies: [1, 17, 7],
    faqs: [
      { question: '《奥本海默》是诺兰的第几部电影？', answer: '克里斯托弗·诺兰执导的第12部长片电影。' },
    ],
  },
  7: {
    content: `<p>《消失的她》是一部由崔睿、刘翔联合执导，朱一龙、倪妮、文咏珊领衔主演的悬疑犯罪电影。影片讲述了何非的妻子李木子在结婚周年旅行中离奇消失，当"妻子"再次现身时，何非却坚称眼前人并非自己的妻子。</p><p>影片采用多重视角叙事，层层反转，将一个看似简单的失踪案演绎成了一部令人窒息的悬疑大戏。</p>`,
    highlights: ['朱一龙封帝之作', '三层反转烧脑不断', '东南亚悬疑美学', '真实事件改编'],
    relatedMovies: [2, 14, 9],
    faqs: [
      { question: '《消失的她》是根据真实事件改编的吗？', answer: '是的，灵感来源于真实事件，改编自中国孕妇泰国坠崖案。' },
    ],
  },
  8: {
    content: `<p>《巨齿鲨2：深渊》是2018年电影《巨齿鲨》的续集，由本·维特利执导，杰森·斯坦森和吴京联袂主演。影片讲述了一支科研小队深入7000米深海探险，意外遭遇史前巨兽巨齿鲨群的惊险故事。</p><p>本片是中美合拍的怪兽动作大片，将深海探险与巨兽对决元素结合，动作场面全面升级。</p>`,
    highlights: ['杰森·斯坦森与吴京双硬汉', '7000米深海探险', '巨齿鲨群围攻升级', '中美合拍巨制'],
    relatedMovies: [3, 1, 19],
    faqs: [
      { question: '《巨齿鲨2》需要看第一部吗？', answer: '建议观看第一部以了解角色背景，但不看也不影响理解第二部的主要剧情。' },
    ],
  },
  9: {
    content: `<p>《人生路不熟》是一部由易小星执导的公路喜剧电影，乔杉、范丞丞、马丽、张婧仪等主演。影片讲述了一对情侣与女方父母共同自驾探亲，在人生路不熟的旅途中发生的一系列爆笑故事。</p><p>影片以轻松诙谐的方式展现了当代中国家庭关系中的种种矛盾与温情，准岳父与准女婿之间从互相看不顺眼到最终和解的过程令人忍俊不禁。</p>`,
    highlights: ['乔杉范丞丞爆笑对决', '公路喜剧新标杆', '温馨家庭情感内核', '马丽金句频出'],
    relatedMovies: [5, 16, 20],
    faqs: [
      { question: '《人生路不熟》是翻拍的吗？', answer: '是原创剧本，讲述了一个关于中国式家庭关系的公路喜剧故事。' },
    ],
  },
  10: {
    content: `<p>《银河护卫队3》是漫威电影宇宙中银河护卫队系列的第三部，也是詹姆斯·古恩执导的该系列收官之作。影片聚焦火箭浣熊的起源故事，护卫队成员为了拯救火箭的生命而踏上了最后一次冒险。</p><p>本片被誉为漫威第四阶段最佳作品之一，情感充沛，笑泪交织。导演在片中为每个角色都安排了完美的结局。</p>`,
    highlights: ['火箭浣熊起源揭晓', '系列最催泪的一部', '詹姆斯·古恩完美收官', '漫威第四阶段最佳'],
    relatedMovies: [18, 3, 1],
    faqs: [
      { question: '《银河护卫队3》是最后一部吗？', answer: '这是詹姆斯·古恩执导的最后一部，但片尾彩蛋暗示了部分角色将以新身份回归。' },
    ],
  },
  11: {
    content: `<p>《长津湖之水门桥》是电影《长津湖》的续集，由徐克执导，吴京、易烊千玺、朱亚文、李晨等原班人马出演。影片以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了七连战士们为阻断美军撤退而执行炸毁水门桥的任务。</p><p>在零下四十度的极寒环境中，志愿军战士们表现出来的顽强意志和牺牲精神令无数观众动容。</p>`,
    highlights: ['真实还原水门桥战役', '零下四十度极寒拍摄', '七连战士催泪告别', '中国影史票房冠军系列'],
    relatedMovies: [19, 1, 7],
    faqs: [
      { question: '《长津湖之水门桥》和《长津湖》是什么关系？', answer: '是《长津湖》的直接续集，承接第一部结尾，讲述七连战士们接下来的战斗任务。' },
    ],
  },
  12: {
    content: `<p>《你的婚礼》是一部由韩天执导，许光汉、章若楠主演的青春爱情电影。影片讲述了一对恋人跨越15年的爱情长跑，从高中时期的懵懂暗恋到成人世界的现实抉择。</p><p>影片以细腻的情感刻画和真实的青春质感打动观众，许光汉和章若楠的银幕情侣形象深入人心。</p>`,
    highlights: ['跨越15年爱情长跑', '许光汉章若楠高甜CP', '笑中带泪的青春回忆', '关于初恋与错过'],
    relatedMovies: [13, 4, 9],
    faqs: [
      { question: '《你的婚礼》是改编自哪部作品？', answer: '改编自韩国同名电影，在保留原作情感内核的基础上进行了本土化改编。' },
    ],
  },
  13: {
    content: `<p>《这么多年》改编自八月长安同名小说，由季竹青执导，张新成、孙千领衔主演。影片讲述了从小在重男轻女环境中长大的陈见夏和叛逆少年李燃之间跨越多年的爱情故事。</p><p>影片以振华中学为背景，延续了"振华三部曲"的青春质感，张新成和孙千将两个不完美但彼此治愈的年轻人的情感变化演绎得真实动人。</p>`,
    highlights: ['八月长安原著改编', '振华三部曲青春延续', '张新成孙千绝美演绎', '关于成长与救赎'],
    relatedMovies: [12, 9, 4],
    faqs: [
      { question: '《这么多年》属于振华三部曲吗？', answer: '属于振华系列作品，与《最好的我们》等一起构建了八月长安的振华宇宙。' },
    ],
  },
  14: {
    content: `<p>《修女2》是招魂宇宙系列电影的最新作品，由迈克尔·查维斯执导，泰莎·法米加回归饰演艾琳修女。影片设定在1956年的法国，讲述了艾琳修女再次面对恶魔瓦拉克的恐怖故事。</p><p>影片延续了招魂宇宙一贯的恐怖氛围和惊悚风格，鬼修女瓦拉克的压迫感全面升级。导演在恐怖元素中融入了更多的悬疑和探案元素。</p>`,
    highlights: ['招魂宇宙最新篇章', '鬼修女瓦拉克回归', '法国修道院恐怖氛围', '泰莎·法米加精彩回归'],
    relatedMovies: [7, 2, 3],
    faqs: [
      { question: '《修女2》需要看《修女1》吗？', answer: '建议先看《修女1》以了解鬼修女瓦拉克的起源，但影片开头也有回闪帮助新观众。' },
    ],
  },
  15: {
    content: `<p>《长安三万里》是一部以唐代为背景的动画电影，由追光动画制作。影片以安史之乱后的动荡时代为背景，通过高适的视角回顾了他与李白长达数十年的友谊。</p><p>影片长达168分钟，以精美绝伦的动画画面还原了盛唐气象，将中国古典诗歌以视觉化的方式呈现。片中出现的48首唐诗让观众在观影的同时重温了中国传统文化的瑰宝。</p>`,
    highlights: ['48首唐诗视觉化呈现', '追光动画巅峰之作', '李白与高适的一生友谊', '盛唐气象完美还原'],
    relatedMovies: [4, 18, 1],
    faqs: [
      { question: '《长安三万里》讲的是谁的故事？', answer: '以高适的视角，回顾了他与李白从青年到老年的数十年友谊，展现了大唐诗坛的璀璨篇章。' },
      { question: '《长安三万里》片长多少？', answer: '片长168分钟，是追光动画最长的作品。' },
    ],
  },
  16: {
    content: `<p>《年会不能停！》是一部以上海为背景的职场讽刺喜剧，由董润年执导，大鹏、白客、庄达菲领衔主演。影片讲述了工厂钳工被误调至集团总部，在一个即将被裁撤的部门中卷入了职场权力斗争的故事。</p><p>影片以幽默犀利的方式讽刺了当代职场中的种种荒诞现象——无意义的会议、职场PUA、办公室政治等，让无数打工人产生了强烈共鸣。</p>`,
    highlights: ['职场讽刺喜剧标杆', '大鹏白客喜剧天花板', '打工人的真实写照', '年会戏份高潮迭起'],
    relatedMovies: [9, 5, 20],
    faqs: [
      { question: '《年会不能停！》是什么类型的电影？', answer: '一部职场讽刺喜剧，以幽默方式反映了当代打工人的真实处境。' },
    ],
  },
  17: {
    content: `<p>《碟中谍7：致命清算（上）》是碟中谍系列的第七部主线作品，由克里斯托弗·麦奎里执导，汤姆·克鲁斯再次饰演超级特工伊森·亨特。影片在全球多国取景。</p><p>汤姆·克鲁斯在片中亲身上演了多项惊险特技，其中包括从悬崖上骑摩托车飞驰而下并定点跳伞的经典镜头。影片在全球获得了良好的口碑和票房。</p>`,
    highlights: ['阿汤哥悬崖飞车跳伞', '全球7国实地取景', 'AI反派全新设定', '系列最大制作规模'],
    relatedMovies: [3, 8, 6],
    faqs: [
      { question: '汤姆·克鲁斯是真的自己拍特技吗？', answer: '是的，他亲自完成了所有特技动作，包括著名的悬崖摩托车跳伞，为此训练了超过一年。' },
    ],
  },
  18: {
    content: `<p>《蜘蛛侠：纵横宇宙》是2018年奥斯卡最佳动画长片《蜘蛛侠：平行宇宙》的续集。影片延续了前作独特的视觉风格，将迈尔斯·莫拉莱斯的故事带入多元宇宙的更广阔舞台。</p><p>影片的美术风格在前作基础上进一步创新，每个蜘蛛侠角色都有自己独特的视觉风格，创造了一场前所未有的视觉盛宴。</p>`,
    highlights: ['奥斯卡获奖续作', '240个蜘蛛侠登场', '多元宇宙视觉革命', '票房口碑双丰收'],
    relatedMovies: [4, 10, 15],
    faqs: [
      { question: '《蜘蛛侠：纵横宇宙》有多少个蜘蛛侠？', answer: '影片中出现了约240个不同版本的蜘蛛侠角色。' },
    ],
  },
  19: {
    content: `<p>《封神第一部：朝歌风云》是乌尔善执导的奇幻史诗巨制，改编自中国古典神魔小说《封神演义》。影片由费翔、李雪健、黄渤、于适、陈牧驰等主演，以宏大的叙事和震撼的视觉效果呈现了中国神话世界。</p><p>影片筹备近十年，集结了顶级制作团队，以实景拍摄与视觉特效结合的方式，打造出一个既有东方韵味又具国际品质的奇幻世界。</p>`,
    highlights: ['十年筹备史诗巨制', '中国神话宇宙开启', '费翔演绎霸气纣王', '顶级视效颠覆想象'],
    relatedMovies: [1, 11, 3],
    faqs: [
      { question: '《封神第一部》什么时候上映的？', answer: '于2023年7月20日在中国内地上映。' },
      { question: '后续什么时候上映？', answer: '《封神第二部》和《封神第三部》目前正在制作中，将陆续与观众见面。' },
    ],
  },
  20: {
    content: `<p>《芭比》是一部由格蕾塔·葛韦格执导的奇幻喜剧，玛格特·罗比和瑞恩·高斯林主演。影片将经典芭比娃娃IP以全新的视角呈现，讲述了一个关于自我发现和女性觉醒的故事。</p><p>影片以粉红色的芭比乐园为舞台，表面光鲜亮丽的世界下隐藏着对性别角色、消费主义和社会规范的犀利讽刺。影片在全球引发了广泛讨论，成为2023年最火爆的文化现象之一。</p>`,
    highlights: ['全球票房破14亿美元', '玛格特·罗比的完美演绎', '犀利的社会议题讽刺', '2023最强文化现象'],
    relatedMovies: [9, 16, 12],
    faqs: [
      { question: '《芭比》全球票房多少？', answer: '全球票房突破14亿美元，是2023年全球票房冠军。' },
    ],
  },
};